import { Icon } from "PFComponents/icon";
import { RoleStatusBadge } from "PFComponents/role/role_status_badge";
import { Typography } from "PFComponents/typography";
import { useRoleName } from "PFCore/helpers/activities";
import React from "react";

import { RoleCardProps } from "../role_card";
import css from "../role_card.module.scss";

type RoleCardHeaderProps = Pick<RoleCardProps, "role">;

export const RoleCardHeader = ({ role }: RoleCardHeaderProps) => {
  const getRoleName = useRoleName();

  const badgeState =
    (!!role.activity.interest_id && "interested") ||
    (!!role.activity.shared_id && "shared") ||
    (role.activity.expires_soon && "expires") ||
    undefined;

  return (
    <div className={css.header}>
      <Typography variant="h5" noMargin>
        {getRoleName(role.activity)}
      </Typography>
      <div className={css.rightSection}>
        <RoleStatusBadge state={badgeState} />
        {role.activity.unread && <Icon name="mail" />}
      </div>
    </div>
  );
};
